import { Category, CategoryEntity } from "./Category";
import { Lifeline } from "./Lifeline";
import { Answer, Difficulty, Question } from "./Question";

export interface GameData {
  isLoading: boolean;
  categories: Array<Category>;
  firstTeamName: string;
  secondTeamName: string;
  currentTeamTurn: TeamTurns;
  firstTeamScore: number;
  secondTeamScore: number;
  shouldPlaySounds?: boolean;
  canAnyTeamChooseAnyQuestion: boolean;
  difficultiesMap: Map<Difficulty, number>;
  firstTeamLifelines: Array<Lifeline>;
  secondTeamLifelines: Array<Lifeline>;
  isUnfinished?: boolean;
  resultGame?: Game;
}

export interface UpdateGameRequestModel {
  action: string;
  index?: number;
  questionId?: string;
  answerId?: string;
  score?: number;
}

export interface Game {
  _id?: string;
  score: number;
  date: Date;
  selectedCategories: Array<GameSelectedCategoryModel>;
  hasGivenRateBoolList?: Array<boolean>;
  questionsList?: Array<Question | undefined>;
  answersList?: Array<Answer | undefined>;
  isPlayedInTrialMode?: boolean;
  shouldPlaySounds?: boolean;
  canAnyTeamChooseAnyQuestion?: boolean;
  difficultiesMap?: {
    easy: number;
    medium: number;
    hard: number;
  };
  firstTeamName?: string;
  secondTeamName?: string;
  firstTeamLifelinesList?: Array<string>;
  secondTeamLifelinesList?: Array<string>;
}

export interface GameRequestModel {
  score: number;
  selectedCategories: Array<{
    category: string;
    selectedSubcategoriesIndexes: Array<number>;
  }>;
  firstTeamName: string;
  secondTeamName: string;
  firstTeamLifelinesList: Array<string>;
  secondTeamLifelinesList: Array<string>;
  difficultiesMap: {
    easy: number;
    medium: number;
    hard: number;
  };
  shouldPlaySounds: boolean;
  canAnyTeamChooseAnyQuestion: boolean;
  isPlayedInTrialMode: boolean;
  platform: Platform;
  device: string;
}

export enum Platform {
  MOBILE = "mobile",
  WEB = "web",
  WEB_MOBILE = "web-mobile",
  UNSPECIFIED = "unspecified",
}

export interface GameSelectedCategoryModel {
  category: CategoryEntity;
  selectedSubcategoriesIndexes: Array<number>;
}

export enum TeamTurns {
  teamA = "teamA",
  teamB = "teamB",
}
